/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {useRouter} from 'next/router';
import moment from 'moment-timezone';
import {truncate} from 'lodash';

import Link from '../../components/Link';
import FacePile from '../../components/FacePile';
import {useAnalytics} from '../../hooks';

const MAX_TITLE_LENGTH = 200;

const QuestionCard = ({question, tag}) => {
  const {tracker} = useAnalytics();
  const router = useRouter();
  const url = `/questions/${question.id}/${question.slug}`;
  const askedOn = moment(question.last_asked_on ?? null);

  const handleClick = () => {
    tracker.hubClickCard({type: 'questions', tag: tag.id, slug: question.slug});
    router.push(url);
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer py-3 px-4 border border-gray-200 rounded-lg transition hover:border-gray-300 hover:bg-gray-50 flex items-center justify-between"
    >
      <div>
        <h3 className="inline text-base font-medium leading-snug text-gray-900">
          <Link href={url}>
            {truncate(question.data.title, {length: MAX_TITLE_LENGTH})}
          </Link>
        </h3>
        {askedOn.isValid() && (
          <span className="text-sm text-gray-500 pl-2">
            Asked
            {' '}
            {askedOn.fromNow()}
          </span>
        )}
      </div>

      <FacePile faces={question.commenters} small className="ml-5 shrink-0" />
    </div>
  );
};

export default QuestionCard;
